import _ from 'lodash';
import { apiFetch } from './utility';

const LOAD_PROJECTED_MONTHLY = 'reports/LOAD_PROJECTED_MONTHLY';
const LOAD_UP_TO_DATE_MONTHLY = 'reports/LOAD_UP_TO_DATE_MONTHLY';
const LOAD_CURRENT_MONTHLY = 'reports/LOAD_CURRENT_MONTHLY';
const LOAD_PRIOR_WEEK = 'reports/LOAD_PRIOR_WEEK';
const LOAD_M_THRU_F = 'reports/LOAD_M_THRU_F';

const initialState = {
	projectedMonthly: undefined,
	priorWeek: undefined,
	priorMondayThroughFriday: undefined,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOAD_PROJECTED_MONTHLY:
			return {
				...state,
				projectedMonthly: action.projectedMonthly,
			};
		case LOAD_UP_TO_DATE_MONTHLY:
			return {
				...state,
				upToDateMonthly: action.upToDateMonthly,
			};

		case LOAD_CURRENT_MONTHLY:
			return {
				...state,
				currentMonthly: action.currentMonthly,
			};

		case LOAD_PRIOR_WEEK:
			return {
				...state,
				priorWeek: action.priorWeek,
			};

		case LOAD_M_THRU_F:
			return {
				...state,
				priorMondayThroughFriday: action.priorMondayThroughFriday,
			};

		default:
			return state;
	}
};

export const getProjectedMonthly = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.projectedMonthly.get',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: LOAD_PROJECTED_MONTHLY,
					projectedMonthly: r,
				});
				callback();
			},
		});
	};
};

export const getUpToDateMonthly = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.upToDateMonthly.get',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: LOAD_UP_TO_DATE_MONTHLY,
					upToDateMonthly: r,
				});
				callback();
			},
		});
	};
};

export const getCurrentMonthly = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.currentMonthly.get',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: LOAD_CURRENT_MONTHLY,
					currentMonthly: r,
				});
				callback();
			},
		});
	};
};

export const getPriorWeek = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.priorWeek.get',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: LOAD_PRIOR_WEEK,
					priorWeek: r,
				});
				callback();
			},
		});
	};
};

export const getPriorMondayThroughFriday = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.priorMondayThroughFriday.get',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: LOAD_M_THRU_F,
					priorMondayThroughFriday: r,
				});
				callback();
			},
		});
	};
};
